import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false
Vue.use(require('vue-moment'))

Vue.component('g-file', require('@/components/review/GFile.vue').default)
Vue.component('g-files-in-folders-list', require('@/components/review/GFilesInFoldersList.vue').default)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
